import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getUserToken } from 'src/shared/utils/session'

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v2/storefront/',
    prepareHeaders: (headers, { getState }) => {
      const token = getUserToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['User', 'UserBom', 'Addresses', 'VendorIntegrations', 'UserConfigurations'],
  endpoints: (builder) => ({
    getUserBoms: builder.query({
      query: ({ q, page }) => `boms/user_boms?${q}&page=${page}&per_page=10`,
    }),
    getUserOrders: builder.query({
      query: ({ q, page }) => `orders/user_orders?${q}&page=${page}&per_page=10`,
    }),
    getCurrentUser: builder.query({
      query: () => 'current_user',
    }),
    getWalletTransactions: builder.query({
      query: ({ q, page }) => `wallet/transactions?${q}&page=${page}&per_page=10`,
    }),
    // getCurrentUserConfigurations: builder.query({
    //   query: () => 'current_user/configurations',
    // }),
    getCurrentUserConfigurationValues: builder.query({
      query: () => 'current_user/configuration_values',
      providesTags: ['UserConfigurations'],
    }),
    getAddresses: builder.query({
      query: () => `addresses`,
      providesTags: ['Addresses'],
    }),
    createAddress: builder.mutation({
      query: (address) => ({
        url: `addresses`,
        method: 'POST',
        body: { address },
      }),
      invalidatesTags: ['Addresses'],
    }),
    updateAddress: builder.mutation({
      query: ({ id, ...address }) => ({
        url: `addresses/${id}`,
        method: 'PATCH',
        body: { address },
      }),
      invalidatesTags: ['Addresses'],
    }),
    deleteAddress: builder.mutation({
      query: (id) => ({
        url: `addresses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Addresses'],
    }),
    setDefaultBillingAddress: builder.mutation({
      query: (id) => ({
        url: `addresses/${id}/set_default_billing`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Addresses'],
    }),
    getAllVendorIntegrations: builder.query({
      query: () => ({
        url: "/vendor_integrations",
        method: "GET",
      }),
    }),
    getVendorIntegration: builder.query({
      query: ({ vendor, unmask = false }) => ({
        url: `/vendor_integrations/${vendor}?unmask=${unmask}`,
      }),
      providesTags: (result, error, { vendor }) => [{ type: 'VendorIntegrations', id: vendor }],
    }),
    updateVendorIntegration: builder.mutation({
      query: ({ vendor, fields }) => ({
        url: `/vendor_integrations/${vendor}`,
        method: 'PATCH',
        body: fields
      }),
      invalidatesTags: (result, error, { vendor }) => [{ type: 'VendorIntegrations', id: vendor }],
    }),
    getCurrentUserPreferences: builder.query({
      query: () => 'current_user/preferences',
      providesTags: ['UserPreferences'],
    }),
    updateCurrentUserConfiguration: builder.mutation({
      query: (body) => {
        return {
          url: 'current_user/configurations',
          method: 'PUT',
          body: body,
        }
      },
    }),
    updateUserWithForm: builder.mutation({
      query: (formData) => ({
        url: 'account',
        method: 'PATCH',
        body: formData,
      }),
      invalidatesTags: ['User'],
    }),
    updateCurrentUserPreferences: builder.mutation({
      query: (body) => {
        return {
          url: 'current_user/preferences',
          method: 'PUT',
          body: body,
        }
      },
      invalidatesTags: (_result, _error, _arg) => [{ type: 'UserPreferences' }],
    }),
  }),
})

export const {
  // useGetUsersQuery,
  useLazyGetUserBomsQuery,
  // useLazyGetUserOrdersQuery,
  useLazyGetWalletTransactionsQuery,
  useLazyGetUserOrdersQuery,
  // useLazyGetUserQuery,
  // useGetUserQuery,
  // useUpdateUserMutation,
  useGetAddressesQuery,
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useSetDefaultBillingAddressMutation,
  useUpdateUserWithFormMutation,
  // useCreateUserMutation,
  // useLazyGetCurrentUserConfigurationsQuery,
  useGetCurrentUserConfigurationValuesQuery,
  useGetCurrentUserPreferencesQuery,
  // useLazyGetCurrentUserPreferencesQuery,
  // useGetCurrentUserQuery,
  // useLazyGetCurrentUserQuery,
  // useUpdateCurrentUserConfigurationMutation,
  useUpdateCurrentUserPreferencesMutation,
  useGetAllVendorIntegrationsQuery,
  useGetVendorIntegrationQuery,
  useUpdateVendorIntegrationMutation
} = userApi